<template>
<svg viewBox="0 0 130 130" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-psm-ziyuan`]" width="1em" height="1em" v-bind="$attrs"><path d="M102,48 L92.1140822,48 C92.1140822,31.6609358 79.9780397,19.1729009 64.5108374,19.1729009 C49.0219603,19.1729009 36.9075927,31.6609358 36.9075927,48 L27,48 C27,28.3889689 43.8080652,9 64.4891626,9 C85.169718,9 102,28.3889689 102,48 Z M115,63.0763651 C115,57.5198385 110.519847,53 105.012782,53 L24.9868078,53 C19.4796054,53 15,57.5198385 15,63.0763651 L15,110.923635 C15,116.480161 19.4796054,121 24.9868078,121 L104.990886,121 C110.497951,121 114.978104,116.480161 114.978104,110.923635 L114.978104,63.0763651 L115,63.0763651 Z M72,100.358864 C72,104.569064 68.6697055,108 64.5337605,108 L63.4666485,108 C59.352651,108 56,104.591384 56,100.358864 L56,79.6411363 C56,75.4309363 59.3307035,72 63.4666485,72 L64.5337605,72 C68.6478943,72 72,75.4086159 72,79.6411363 L72,100.358864 Z" :fill="useCurrentColor ? 'currentColor' : '#4E5969'" fill-rule="evenodd"/></svg>
</template>
<script>

export default {
  name: 'IconPsmZiyuan',
  props: {
    prefix: {
        type: String,
        default: 'psm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
